import { coreSonarObjectsOptimisticChangeAddSlice } from './add';
import { coreSonarObjectsOptimisticChangeRemoveSlice } from './remove';
import { defaultSonarObjectsOptimisticChangeState } from './state';
import { joinSyncReducers } from '@sonar-software/xuder';

export const coreSonarObjectsOptimisticReducers = joinSyncReducers(
	[ coreSonarObjectsOptimisticChangeAddSlice.syncReducer, coreSonarObjectsOptimisticChangeRemoveSlice.syncReducer ],
	defaultSonarObjectsOptimisticChangeState
);
